import { render, staticRenderFns } from "./CustomerSupportChatBotLink.vue?vue&type=template&id=1ce34050"
import script from "./CustomerSupportChatBotLink.vue?vue&type=script&lang=js"
export * from "./CustomerSupportChatBotLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports